module.exports = __webpack_public_path__ + "static/media/share-square.8b3addcc.svg";